import { takeLatest, all, put } from 'redux-saga/effects';
import Actions from "../action";
import { NOTIFICATION_HISTORY } from '../action/NotificationHistoryAction'
import { doGet } from '../../service/index';
import END_POINTS from './EndPoints';

export function* notificationHistory({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.NOTIFICATION_HISTORY_API, params)
        yield put(Actions.notificationHistorySuccessAction(response));
        if (callback) {
            callback(response)
        }
    } catch (error) {
        yield put(Actions.notificationHistoryFailureAction({ error }));
        if (callback) {
            callback(error)
        }
    }
}
export default function* notificationHistoryWatcher() {
    yield all([
        takeLatest(NOTIFICATION_HISTORY, notificationHistory),
    ]);
}